var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 0.613525,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5816 11.7686H24.904L19.8301 17.5682L25.7995 25.4586H21.1257L17.4654 20.6725L13.2763 25.4586H10.9527L16.38 19.255L10.6536 11.7692H15.446L18.7547 16.1438L22.5816 11.7686ZM21.7669 24.0689H23.0536L14.7467 13.0856H13.3659L21.7669 24.0689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterDark);
export default __webpack_public_path__ + "static/media/TwitterDark.af700b85c3c16300bf1bb541faddece7.svg";
export { ForwardRef as ReactComponent };